module.exports = __webpack_public_path__ + "img/Email.9d7fd1a5.png";